module.exports = __webpack_public_path__ + "static/Blogger-bfe2bcdc25571da9b600381d249ebd25.png";